import React, { useRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import API from '../../../../API';
import $ from 'jquery';
import { cardToken } from '../../../../reducers/feed/feed.actions';
import { useDispatch, useSelector } from 'react-redux';

const Payments = () => {
 


  return (
    <div className={'col-12 col-md-6 px-3 py-4'} style={{ minHeight: '100%' }}>
    </div>
  );
};

export default Payments;
